import React from 'react'
import CardItem from './CardItem'
import './Cards.css'

function Cards() {
  return (
    <div className='cards'>
        <h1>Our services</h1>
        <div className='cards__container'>
            <div className='cards__wrapper'>
                <ul className='cards__items'>
                    <CardItem
                    src='images/img_computer1.webp'
                    text='Cloud Consulting and Migrations'
                    label='Cloud'
                    // path='/services'
                    />
                    <CardItem
                    src='images/img_computer4.jpg'
                    text='DevOps & Automation'
                    label='DevOps'
                    />
                </ul>
                <ul className='cards__items'>
                    <CardItem
                    src='images/img_computer3.webp'
                    text='Data Modernization & Analytics'
                    label='Data'
                    />
                    <CardItem
                    src='images/img_computer5.webp'
                    text='Artificial Intelligence, Machine Learning & MLOps'
                    label='AI/ML'
                    />
                    <CardItem
                    src='images/img_security.webp'
                    text='Infrastructure & DevOps Modernization'
                    label='Infrastructure'
                    />
                </ul>
        </div>
        </div>
    </div>
  )
}

export default Cards